/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: collaboratif-webapp-contrib
 * Version: 7.3.0-ALPHA-1
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
jQuery.extend(
    true, window.LOCALE_BO, {
        collaboratif: {
            refusalTitle: "Refuse",
            confirmSupprMembreEspace: "You are about to remove the user [utilisateur] from the space",
            tree: {
                add: "Add",
                delete: "Delete",
                edit: "Edit",
                popinAddTitle: "Folder adding",
                popinModifyTitle: "Folder modification",
                valider: "Validate",
                annuler: "Cancel"
            }
        }
    });
